<template>
  <picture v-if="darkSrc" class="themed-picture">
    <source :media="darkMedia" :srcset="darkSrc">
    <slot/>
  </picture>
  <slot v-else/>
</template>

<script setup lang="ts">
defineProps<{
  darkSrc?: string | null;
}>();

const { darkMedia } = useColorTheme();
</script>

<style scoped lang="scss">
.themed-picture {
  display: contents;
}
</style>
